import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=ddec2ea2&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=ddec2ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec2ea2",
  null
  
)

export default component.exports